import React from "react";
import { Link } from "react-router-dom";
import useAdInfo from "../ads/useAdInfo";

// The cards of what organizations can do with Cloud Print: have a kiosk placed, buy
// kiosks, or show ads on the screens. Each opens its page and request form. Shown on
// the home page (HomePartners.js), on /partners (PartnerHub.js), and under each of
// those pages with its own card left out (`except`). The ads card waits until admins
// turn ads on, as /advertise does. Styled in App.css (.home-offer-*).

const OFFERS = [
  {
    to: "/place-kiosk",
    tone: "is-place",
    icon: "fa-store-alt",
    title: "Киоск байршуулах",
    text: "Сургууль, оффис, дэлгүүртээ хэвлэлийн киоск байрлуулаарай. Суурилуулж, цаас, бэх, засварыг нь бид хариуцна.",
  },
  {
    to: "/buy-kiosk",
    tone: "is-buy",
    icon: "fa-handshake",
    title: "Киоск худалдаж авах",
    text: "Байгууллагадаа өөрийн киосктой болоорой. Програмыг нь ажиллуулж, засвар үйлчилгээг нь бид хийнэ.",
  },
  {
    to: "/advertise",
    tone: "is-ads",
    icon: "fa-bullhorn",
    title: "Реклам байршуулах",
    text: "Хэвлэхээр ирсэн хүн бүрийн хардаг киоскийн дэлгэц дээр брэнд, бүтээгдэхүүнээ харуулаарай.",
    ads: true,
  },
];

// The pages the cards open, for the menu link that stays marked on them
export const PARTNER_PATHS = ["/partners", ...OFFERS.map((offer) => offer.to)];

const PartnerOffers = ({ except }) => {
  const { state } = useAdInfo();
  const offers = OFFERS.filter((offer) => offer.to !== except && (!offer.ads || state === "ready"));
  if (offers.length === 0) return null;

  return (
    <ul className="home-offer-grid">
      {offers.map((offer) => (
        <li key={offer.to}>
          <Link to={offer.to} className={"home-offer-card " + offer.tone}>
            <span className="home-offer-icon" aria-hidden="true">
              <i className={"fas " + offer.icon}></i>
            </span>
            <h3>{offer.title}</h3>
            <p>{offer.text}</p>
            <span className="home-offer-go">
              Дэлгэрэнгүй <i className="fas fa-arrow-right" aria-hidden="true"></i>
            </span>
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default PartnerOffers;
